<template>
  <div v-show="eventVisible" id="score-compare-box">
    <div v-if="selectedOptions" class="score-compare-select-box">
      <div class="score-compare-select score-compare-select-comp">
        比赛名称：
        <a-select :value="selectedOptions.selectedComp" @change="handleChangeComp">
          <a-select-option :value="''">所有比赛</a-select-option>
          <a-select-option
            v-for="comp in allCompetitions"
            :key="`score-select-comp-${comp.match_name}`"
            :value="comp.match_id">
            {{comp.start_date[0]}}-{{comp.match_name}}-{{comp.location}}
          </a-select-option>
        </a-select>
      </div>
      <div class="score-compare-select">
        比赛类别：
        <a-select :value="selectedOptions.selectedType" @change="handleChangeType">
          <a-select-option :value="''">所有类别</a-select-option>
          <a-select-option
            v-for="type in compTypeOptions"
            :key="`score-select-type-${type.value}`"
            :value="type.value">
            {{type.abbre}}
          </a-select-option>
        </a-select>
      </div>
      <div class="score-compare-select">
        球员：
        <a-select :value="selectedOptions.selectedPlayer" @change="handleChangePlayer">
          <a-select-option
            v-for="player in playerList"
            :key="`score-select-player-${player.player_id}`"
            :value="player.player_id">
            {{player.player_name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="score-compare-select score-compare-select-date">
        时间：<a-date-picker :value="selectedOptions.selectDate1" :locale="locale" @change="(date, dateString) => onChangeDate(dateString, 1)"/>
        &nbsp; <span style="font-weight: 400;">—</span> &nbsp;
        <a-date-picker :value="selectedOptions.selectDate2" :locale="locale" @change="(date, dateString) => onChangeDate(dateString, 2)"/>
      </div>
      <div class="score-compare-select score-compare-select-submit">
        <a-button type="primary" style="width: 60px; height:30px;" @click="submit">
          搜索
        </a-button>

      </div>

    </div>
    <div class="score-compare-statistic-box">
      <div class="score-compare-title">———— 数据统计 ————</div>
      <div v-if="eventCount && eventFilterInfo && currentPlayer" class="score-compare-info">
        <div class="info-box-player">
          <div class="info-box-title">
            <div class="info-box-subtitle" style="width:100%;">球员</div>
          </div>
          <div class="info-box-info member-info">
            <img class="flag"
              src="https://documentstore.ittf.com/websitefiles/assets/flags_normal/cn.png"
              @error="setDefaultImage"/>
            <img class="icon"
              :src="getPlayerIconUrl(allPlayers[currentPlayer].player_wtt_id,
                allPlayers[currentPlayer].player_eng_name)"
              @error="setDefaultImage"/>
            <span class="member-name">{{allPlayers[currentPlayer].player_name}}</span>
          </div>
        </div>
        <div class="info-box-score">
          <div class="info-box-title">
            <div class="info-box-subtitle">参赛站数</div>
            <div class="info-box-subtitle" v-if="selectedOptions.selectedType==='' || !selectedOptions.selectedType.includes('team')">个人奖牌数</div>
            <div class="info-box-subtitle" v-if="selectedOptions.selectedType==='' || selectedOptions.selectedType.includes('team')">团体奖牌数</div>

          </div>
          <div class="info-box-info" target="_border">
            <div class="info-box-subinfo">{{eventCount.event}}</div>
            <!-- 个人奖牌数部分 -->
            <div class="info-box-subinfo" v-if="selectedOptions.selectedType==='' || !selectedOptions.selectedType.includes('team')">
              <!-- 包裹奖牌文字，加自定义类medal-text -->
              <span class="medal-text">
                {{"金"+medalForSelectedType[0]+" 银"+medalForSelectedType[1]+" 铜"+medalForSelectedType[2]}}
              </span>
            </div>

            <!-- 团体奖牌数部分 -->
            <div class="info-box-subinfo" v-if="selectedOptions.selectedType==='' || selectedOptions.selectedType.includes('team')">
            <span class="medal-text">
              {{"金"+medalTeam[0]+" 银"+medalTeam[1]+" 铜"+medalTeam[2]}}
            </span>
            </div>
          </div>
        </div>
        <div class="info-box-score">
          <div class="info-box-title">
            <div class="info-box-subtitle">获胜场次</div>
            <div class="info-box-subtitle">场次胜率</div>
          </div>
          <div class="info-box-info" target="_border">
            <div class="info-box-subinfo info-box-subinfo-in">{{eventCount.gameWin+'/'+eventCount.game}}</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{eventCountOut.gameWin+'/'+eventCountOut.game}}</div>
            <div class="info-box-subinfo info-box-subinfo-in">{{getPecentage('game')}}%</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{getPecentageOut('game')}}%</div>
          </div>
        </div>
        <div class="info-box-score">
          <div class="info-box-title">
            <div class="info-box-subtitle">获胜局数</div>
            <div class="info-box-subtitle">局胜率</div>
          </div>
          <div class="info-box-info" target="_border">
            <div class="info-box-subinfo info-box-subinfo-in">{{eventCount.rallyWin+'/'+eventCount.rally}}</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{eventCountOut.rallyWin+'/'+eventCountOut.rally}}</div>
            <div class="info-box-subinfo info-box-subinfo-in">{{getPecentage('rally')}}%</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{getPecentageOut('rally')}}%</div>
          </div>
        </div>
        <div class="info-box-score">
          <div class="info-box-title">
            <div class="info-box-subtitle">获胜分数</div>
            <div class="info-box-subtitle">回合胜率</div>
          </div>
          <div class="info-box-info" target="_border">
            <div class="info-box-subinfo info-box-subinfo-in">{{eventCount.scoreWin}}</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{eventCountOut.scoreWin}}</div>
            <div class="info-box-subinfo info-box-subinfo-in">{{getPecentage('score')}}%</div>
            <div class="info-box-subinfo info-box-subinfo-out">{{getPecentageOut('score')}}%</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="selectedOptions" class="score-compare-list-box">
      <div class="score-compare-title">———— 比赛列表 ————</div>
      <div v-if="sortedEventFilterList && sortedEventFilterList.length>0" class="list-box">
        <div v-for="(box, index) in sortedEventFilterList"
          :key="`score-compare-list-${index}`"
          class="list-box-cell">
          <CompCard v-if="selectedOptions" :value="{
            eventId: box.eventId,
            eventName: box.match_name,
            time: box.subEventDate,
            subEventName: box.subEvent,
            competitors: box.competitors,
            resultsGameScores: box.resultsGameScores,
            resultOverallScores: box.resultOverallScores,
            selectedPlayer: selectedOptions.selectedPlayer,
          }"/>
        </div>
      </div>
      <div v-else class="list-empty">
        <a-empty :description="'暂无数据'"/>
      </div>
    </div>
    <div class="score-compare-close-button">
      <a-button type="primary" style="width: 560px; height: 45px;" @click="closePanel">
        关闭
      </a-button>
        <a-button v-if="$route.path==='/table'"
                  type="link"
                  style="border: 1px solid white;background-color: #0072be;color: #FFFFFF;position: absolute;right: 40px;"
                  :href="downloadUrl()"
                  target="_blank"
        >导出</a-button>
    </div>

  </div>

</template>

<script>
import defaultImage from '@/assets/icon.png'
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import CompCard from './CompCard.vue'
import utils from '../../utils/cardIcon.js'
import {compTypeOptions, allSubType, MatchDescription} from '../../utils/common.js'
import {getEvent, url} from "@/api";
import {getToken} from "@/api/http";
import {string} from "postcss-selector-parser";

export default {
  name: "ScoreCompare",
  components: {
    CompCard,
  },
  data() {
    return {
      locale,
      eventList: [],
      eventFilterList: [],
      eventCount: null,
      compTypeOptions: null,
      selectedOptions: null,
      allSubType: allSubType,
      currentPlayer: '',
      eventCountOut:null,
      eventFilterListOut:[],
    };
  },
  props: {
  },
  computed: {
    eventVisible() {
      return this.$store.state.eventVisible
    },
    eventData() {
      return this.$store.state.eventData
    },
    eventFilterInfo() {
      return this.$store.state.eventFilterInfo
    },
    allPlayers() {
      return this.$store.state.tablePlayers
    },
    allCompetitions() {
      return this.$store.state.matchListAll
    },
    playerList() {
      return Object.values(this.$store.state.tablePlayers)
    },
    medalForSelectedType(){
      if (!this.selectedOptions ){
        return [0,0,0]
      }
      if (!this.selectedOptions.selectedType){
        return this.$store.state.medal.medalAllAsPerson
      }
      if(this.selectedOptions.selectedType==='men single' || this.selectedOptions.selectedType==='women single'){
        return this.$store.state.medal.medalSingle
      }else if(this.selectedOptions.selectedType==='men double' || this.selectedOptions.selectedType==='women double'){
        return this.$store.state.medal.medalDouble
      }else if(this.selectedOptions.selectedType==='men mixed' || this.selectedOptions.selectedType==='women mixed'){
        return this.$store.state.medal.medalMixed
      }else{
        return this.$store.state.medal.medalAllAsPerson
      }
    },
    medalTeam(){
      if(!this.$store.state.medal){
        return [0,0,0]
      }else {
        return this.$store.state.medal.medalTeam
      }
    },
    playerName() {
      let result = ''
      if(this.eventFilterInfo && this.eventFilterInfo.player) {
        if(this.eventFilterInfo.player.length && this.eventFilterInfo.player.length > 0) {
          result = this.eventFilterInfo.player.map(item => this.allPlayers[item].player_name).join('&')
        }
      }
      return result
    },

    compName() {
      return this.allCompetitions.find(item => item.match_id===this.selectedOptions.selectedComp)?(this.allCompetitions.find(item => item.match_id===this.selectedOptions.selectedComp).match_name):''
    },
    sortedEventFilterList() {
      // 先判断原数组是否有值，避免空数组排序报错
      if (!this.eventFilterList || this.eventFilterList.length === 0) {
        return [];
      }

      const selectedPlayerId = this.currentPlayer;
      if (!selectedPlayerId) {
        return this.eventFilterList; // 如果没有选中的球员，返回原始顺序
      }

      // --- 核心修改：更精细的比赛类型优先级映射 ---
      // 数字越小，优先级越高。严格区分个人和团体项目。
      const matchTypePriority = {
        // --- 个人单打 (优先级 1) ---
        '男单': 1,
        '女单': 1,
        // --- 团体单打 (优先级 2) ---
        '男团单打': 2,
        '女团单打': 2,
        '混团男单': 2,
        '混团女单': 2,
        // --- 个人双打 (优先级 3) ---
        '男双': 3,
        '女双': 3,
        // --- 团体双打 (优先级 4) ---
        '男团双打': 4,
        '女团双打': 4,
        '混团男双': 4,
        '混团女双': 4,
        // --- 个人混双 (优先级 5) ---
        '混双': 5,
        // --- 团体混双 (优先级 6) ---
        '混团混双': 6,
      };

      // 辅助函数：获取比赛类型的排序分类
      const getMatchTypeCategory = (match) => {
        if (!match.subEvent) return 99; // 如果没有subEvent，排在最后
        const typeName = match.subEvent.split(' - ')[0];
        return matchTypePriority[typeName] || 99; // 返回对应的优先级数字，找不到则排在最后
      };

      // 辅助函数：判断是否为外战
      const isForeignMatch = (match) => {
        if (!match.competitors || match.competitors.length < 2 || !match.competitors[0].competitiorOrg || !match.competitors[1].competitiorOrg) return false;
        const competitor1Org = match.competitors[0].competitiorOrg;
        const competitor2Org = match.competitors[1].competitiorOrg;
        const isSide1Ours = competitor1Org.includes('CHN');
        const isSide2Ours = competitor2Org.includes('CHN');
        return isSide1Ours !== isSide2Ours;
      };

      // 辅助函数：根据比赛结果获取排序优先级
      const getMatchResultCategory = (match) => {
        const playerIndex = match.competitors[0].players
            .some(p => p.player_cn_id_in_db === selectedPlayerId) ? 0 : 1;

        const scores = match.resultOverallScores.split('-').map(Number);
        const didWin = scores[playerIndex] > scores[1 - playerIndex];
        const isDraw = scores[0] === scores[1];

        const isMixedTeam = (match.subEventName || '').toLowerCase().includes('mixed team');
        const foreignMatch = isForeignMatch(match);

        if (!didWin && foreignMatch) return 1; // (1) 外战输
        if (isDraw && isMixedTeam) return 2;   // (2) 平局(混团)
        if (!didWin && !foreignMatch) return 3; // (3) 内战输
        if (didWin && foreignMatch) return 4;   // (4) 外战赢
        if (didWin && !foreignMatch) return 5;  // (5) 内战赢

        return 99; // 其他情况的备用值
      };

      // 复制原数组（避免修改原数据）
      const sortedList = [...this.eventFilterList];

      // 执行多级排序
      sortedList.sort((a, b) => {
        // 第一层排序：按输赢内外战分类
        const resultCategoryA = getMatchResultCategory(a);
        const resultCategoryB = getMatchResultCategory(b);
        if (resultCategoryA !== resultCategoryB) {
          return resultCategoryA - resultCategoryB;
        }

        // 第二层排序：在第一层分类相同的情况下，按比赛类型（个人单打 > 团体单打 > ...）排序
        const typeCategoryA = getMatchTypeCategory(a);
        const typeCategoryB = getMatchTypeCategory(b);
        return typeCategoryA - typeCategoryB;

        // 如果两层排序结果都相同, 稳定的sort会保留其原始相对顺序（Final -> 半决赛等）
      });

      return sortedList;
    },
  },
  watch: {
    eventData: {
      handler(value) {
        if (!value) return;
        this.eventFilterList = JSON.parse(JSON.stringify(value));
        this.eventFilterList.forEach(comp => {
          const description = comp.subEventDescription.trim();

          let subEventEn = '';
          let descriptionEn = '';
          // let subEventIndex = '';

          // 通过'-'的数量判断新旧格式
          const separatorCount = (description.match(/-/g) || []).length;

          if (separatorCount === 2) {
            // --- 旧格式处理 ---
            // "Men's Singles - Round of 16 - Match 6"
            const parts = description.split(' - ').map(p => p.trim());
            subEventEn = parts[0];
            descriptionEn = parts[1];
            // subEventIndex = (parts[2] || '').replace('Match', '').trim();

          } else if (separatorCount === 1) {
            // --- 新格式处理 ---
            // "Men's Singles R 16 - Match 4"
            // "U17 Men's Singles Round 1 - Match 1"
            const parts = description.split(' - ').map(p => p.trim());
            const firstPart = parts[0]; // "Men's Singles R 16"
            // subEventIndex = (parts[1] || '').replace('Match', '').trim();

            const isYouthEvent = firstPart.startsWith('U');
            const words = firstPart.split(' ');

            // 根据是否为青年赛事，决定赛事类型占几个单词
            const subEventTypeWordCount = isYouthEvent ? 3 : 2;

            if (words.length > subEventTypeWordCount) {
              subEventEn = words.slice(0, subEventTypeWordCount).join(' '); // "Men's Singles" 或 "U17 Men's Singles"
              descriptionEn = words.slice(subEventTypeWordCount).join(' '); // "R 16" 或 "Round 1"
            } else {
              // 如果单词数不够，则全部视为赛事类型
              subEventEn = firstPart;
            }

          } else {
            // 其他未知格式，直接显示原文
            comp.subEvent = description;
            return; // 跳过后续处理
          }

          // --- 翻译和拼接逻辑 (带回退机制) ---

          // 1. 翻译赛事类型，找不到则保留英文
          subEventEn = comp.subEventName
          let subEvent = allSubType.find(item => item.list.includes(subEventEn))?.type || subEventEn;
          // 如果是男团 还看一下是单打还是双打
          if(subEvent==='男团'){
            if(comp.competitors[0].players[1].playerName && comp.competitors[0].players[1].playerWTTId && comp.competitors[0].players[1].playerName.length>0 && comp.competitors[0].players[1].playerWTTId.length>0){
              subEvent=subEvent+'双打'
            }else{
              subEvent=subEvent+'单打'
              // console.log('---'+comp.competitors[0].players[1].playerName+'==='+comp.competitors[0].players[1].playerWTTId+'===')
            }
          }else if(subEvent==='女团'){
            if(comp.competitors[0].players[1].playerName && comp.competitors[0].players[1].playerWTTId && comp.competitors[0].players[1].playerName.length>0 && comp.competitors[0].players[1].playerWTTId.length>0){
              subEvent=subEvent+'双打'
            }else{
              subEvent=subEvent+'单打'
              // console.log('---'+comp.competitors[0].players[1].playerName+'==='+comp.competitors[0].players[1].playerWTTId+'===')
            }
          }
          // 2. 翻译比赛阶段，找不到则保留英文
          let finalDescription = descriptionEn;
          if (descriptionEn) {
            const descriptionRule = MatchDescription.find(item => item.key.includes(descriptionEn));
            if (descriptionRule) {
              finalDescription = descriptionRule.label;
            }
          }

          // 3. 安全地拼接最终字符串
          const resultParts = [];
          if (subEvent) resultParts.push(subEvent);
          if (finalDescription) resultParts.push(finalDescription);
          // if (subEventIndex) resultParts.push(subEventIndex);

          comp.subEvent = resultParts.join(' - ');
        });

        // 后续代码保持不变...
        this.filterEventListOut();
        if (this.selectedOptions) {
          this.eventCount = this.countScore(this.eventFilterList);
        }
        if (this.selectedOptions && this.eventFilterListOut) {
          this.eventCountOut = this.countScore(this.eventFilterListOut);
        }

      },
      immediate: true,
      deep: true,
    },
    eventFilterInfo: {
      handler(value) {
        if(value) {
          this.selectedOptions = {
            selectedComp: '',
            selectedType: '',
            selectedPlayer: '',
            selectDate1: '',
            selectDate2: '',
          }

          this.selectedOptions.selectedComp = value.comp
          // const mapGender = {'male': '男', 'men': '男','female': '女', 'women': '女',}
          // const mapType = {'single': '单', 'double': '双','mixed': '双', 'team': '团',}
          // this.selectedOptions.selectedType = value.type === 'mixed' ? '混双' : (value.type==='team'?(mapGender[value.gender]==='男'?'所有团体':'所有团体'):`${mapGender[value.gender]}${mapType[value.type]}`)

          // --- 核心修改部分 ---
          // 删除原来的那行 this.selectedOptions.selectedType = ...

          let subTypeEn = '';
          const type = value.type;   // e.g., 'single'
          const gender = value.gender; // e.g., '女' or 'women'

          // 这段逻辑参考了您描述中 setType 函数里的 subTypeEn 构造方式
          if (type === 'mixed') {
            subTypeEn = 'mixed';
          } else if (type === 'team') {
            // 根据 compTypeOptions，'所有团体' 的 value 是 'team men' 或 'team women'
            subTypeEn = (gender === '男' || gender === 'men' || gender==='male') ? 'team men' : 'team women';
          } else { // 'single' or 'double'
            const genderEn = (gender === '男' || gender === 'men' || gender==='male') ? 'men' : 'women';
            subTypeEn = `${genderEn} ${type}`; // e.g., "women single"
          }

          // 将拼接好的正确英文 value 赋给 selectedType
          this.selectedOptions.selectedType = subTypeEn;
          // --- 修改结束 ---


          this.selectedOptions.selectedPlayer = this.allPlayers[value.player[0]].player_id
          this.currentPlayer = this.selectedOptions.selectedPlayer

          const teamType = ['women', 'men', 'mix'].find(value => this.$store.state.currentTeam.includes(value))
          this.compTypeOptions = teamType=='mix'? [...compTypeOptions['women'], ...compTypeOptions['men'], ...compTypeOptions['mix']]:
            [...compTypeOptions[teamType], ...compTypeOptions['mix']]

          const compInfo = this.allCompetitions.find(item => item.match_id == value.comp)
          this.selectedOptions.selectDate1 = this.getTimeString(compInfo.start_date)
          this.selectedOptions.selectDate2 = this.getTimeString(compInfo.end_date)

          // console.log("eventFilterInfo",this.eventFilterList)
          this.filterEventListOut()
          // console.log("eventFilterInfo",this.eventFilterListOut)
          if(this.eventData && this.eventData.length > 0) {
            this.eventCount = this.countScore(this.eventFilterList)
          }
          if(this.eventData && this.eventData.length > 0&&this.eventFilterListOut){
            this.eventCountOut=this.countScore(this.eventFilterListOut)
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    string,
    downloadUrl() {
      const value = this.selectedOptions
      if (this.eventCount) {
        return url('/score/event_data_specific_export', {
          token: getToken(),
          match_id: value.selectedComp,
          match_name: this.compName,
          subType: value.selectedType,
          player_id: value.selectedPlayer,
          player: this.allPlayers[value.selectedPlayer]["player_name"],
          startTime: value.selectDate1 === '' ? '1000-01-01' : value.selectDate1,
          endTime: value.selectDate2 === '' ? '9999-12-31' : value.selectDate2,
          gameWin: this.eventCount.gameWin,
          gamePec: this.getPecentage('game') + '%',
          rallyWin: this.eventCount.rallyWin,
          rallyPec: this.getPecentage('rally') + '%',
          scoreWin: this.eventCount.scoreWin,
          scorePec: this.getPecentage('score') + '%',
          scoreFail: this.eventCount.scoreFail
        })
      } else {
        return null
      }

    },
    setDefaultImage(e) {
      e.target.src = defaultImage
    },
    getPecentage(name) {
      if (this.eventCount[name] == 0) return 0;
      else return Math.round(this.eventCount[`${name}Win`] * 100 / this.eventCount[name])
    },
    getPecentageOut(name) {
      if (this.eventCountOut[name] == 0) return 0;
      else return Math.round(this.eventCountOut[`${name}Win`] * 100 / this.eventCountOut[name])
    },
    getTimeString(att) {
      let result = ''
      result += att[0]
      result += '-'
      if (att[1] < 10) result += '0'
      result += att[1]
      result += '-'
      if (att[2] < 10) result += '0'
      result += att[2]
      return result
    },
    getCol(row) {
      if (row < Math.ceil(this.eventFilterList.length / 3)) {
        return 3
      } else {
        return this.eventFilterList.length % 3
      }
    },
    countScore(comps) {
      const result = {
        event: 0,
        // event_champion: 0,
        game: 0,
        gameWin: 0,
        rally: 0,
        rallyWin: 0,
        score: 0,
        scoreWin: 0,
        scoreFail: 0
      }
      let event_station_match_dict = {}
      comps.forEach(comp => {
        const playerId = this.currentPlayer
        const selectPlayerIndex = comp.competitors[0].players
            .map(item => item.player_cn_id_in_db)
            .includes(playerId) ? 0 : 1
        // debugger
        if (comp.eventId in event_station_match_dict) {
          // 存在则向已有数组追加值
          event_station_match_dict[comp.eventId].push(comp.subEventDescription);
        } else {
          // 不存在则直接初始化包含当前值的数组（简化逻辑）
          event_station_match_dict[comp.eventId] = [comp.subEventDescription];
        }

        const rally = comp.resultOverallScores.split('-').map(value => parseInt(value))
        result.game += 1
        result.gameWin += (rally[selectPlayerIndex] > rally[1 - selectPlayerIndex] ? 1 : 0)

        // if (comp.subEvent.split(' - ')[1] === '决赛'){
        //   if (rally[selectPlayerIndex] > rally[1 - selectPlayerIndex]){
        //     result.event_champion+=1
        //   }
        //
        // }

        result.rally += (rally[0] + rally[1])
        result.rallyWin += rally[selectPlayerIndex]
        const scores = comp.resultsGameScores.split(',').map(rallyValue => {
          return rallyValue.split('-').map(value => parseInt(value))
        })
        scores.forEach(score => {
          result.score += (score[0] + score[1])
          result.scoreWin += score[selectPlayerIndex]
          result.scoreFail += score[selectPlayerIndex === 0 ? 1 : 0]
        })
      })
      result.event = Object.keys(event_station_match_dict).length;
      // console.log('result=',result.event_champion)
      return result
    },
    closePanel() {
      // this.$store.commit('setEventFilterData', {'eventVisible': false})
      this.$store.commit('setEventFilterData',{
        'comp': '',
        'eventVisible': false,
        'type': '',
        'gender': '',
        'player': ['']
      })
    },
    getPlayerIconUrl(id, name, type = 'lower') {
      return utils.getPlayerIconUrl(id, name, type)
    },

    handleChangeComp(value) {
      this.selectedOptions.selectedComp = value
    },
    handleChangeType(value) {
      this.selectedOptions.selectedType = value
    },
    handleChangePlayer(value) {
      this.selectedOptions.selectedPlayer = value
    },
    onChangeDate(dateString, index) {
      this.selectedOptions[`selectDate${index}`] = dateString
    },
    submit() {
      const value = this.selectedOptions
      this.$store.state.loading = true
      this.get_eventData(
          value.selectedComp,
          value.selectedType,
          value.selectedPlayer,
          value.selectDate1 == '' ? '1000-01-01' : value.selectDate1,
          value.selectDate2 == '' ? '9999-12-31' : value.selectDate2,
      ).then(() => {this.$store.state.loading = false;
        this.filterEventListOut()
        if(this.eventData && this.eventData.length > 0) {
          this.eventCount = this.countScore(this.eventFilterList)
        }
        if(this.eventData && this.eventData.length > 0&&this.eventFilterListOut){
          this.eventCountOut=this.countScore(this.eventFilterListOut)
        }
      })
      this.currentPlayer = value.selectedPlayer
    },
    async get_eventData(match_id, subType, player_id, start_time, end_time) {
      // let str_to_parse="Men's Singles - Final - Match 1"
      // let final = str_to_parse.split('-')[1].split(' ')[1]
      // console.log(final)
      try {
        const response = await getEvent(match_id, subType, player_id, start_time, end_time)
        // console.log("res", response.data.data)
        if (response.status === 200) {
          if (response.data.success) {
            this.$store.commit('setEventData', response.data.data.subEvent)
            this.$store.commit('setMedal',response.data.data.medal)
            return true
          }
        }
      } catch (e) {
        console.log(e)
      }
      return false
    },
    filterEventListOut() {
      this.eventFilterListOut = this.eventFilterList.filter(comp => {
        // 安全检查，防止 competitors 数组不存在或长度不足
        if (!comp.competitors || comp.competitors.length < 2) {
          return false;
        }

        const competitor1Org = comp.competitors[0].competitiorOrg;
        const competitor2Org = comp.competitors[1].competitiorOrg;

        // ----- 新逻辑开始 -----

        // 定义一方是否为“我方”（只要组织名包含 'CHN'）
        const isSide1Ours = competitor1Org.includes('CHN');
        const isSide2Ours = competitor2Org.includes('CHN');
        const isOutComp = isSide1Ours !== isSide2Ours;


        return isOutComp;
      });
    }
  }
}
</script>

<style lang="less" scoped>
#score-compare-box{
  position: absolute;
  z-index: 101;
  top: 5vh;
  height: calc(100% - 91px);
  width: calc(100% - 128px);
  margin-left: 64px;
  margin-right: 64px;
  background: white;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);
  border-radius: 6px;
  padding: 25px 40px 25px 40px;

  .score-compare-title {
    width: 100%;
    height: 24px;

    font-family: 'Lantinghei SC';
    font-style: normal;
    font-weight: 800;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    text-align: center;
    letter-spacing: -0.015em;

    color: #000000;
  }

  .score-compare-select-box {
    width: 100%;
    height: 59px;
    display: flex;
    position: relative;

    .score-compare-select {
      height: 35px;
      width: calc(50% - 520px);
      // margin-right: 135px;
      text-align: left;
      line-height: 35px;
      //margin-left: 10px;
      font-family: 'Lantinghei SC';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      letter-spacing: -0.015em;
      color: #000000;
    }

    .score-compare-select-comp {
      width: 580px;

      /deep/ .ant-select {
        width: 335px;
      }
    }
    .score-compare-select-date {
      width: 510px;
    }
    .score-compare-select-submit {
      width: 60px;
      position: absolute;
      right: 0;
    }

    /deep/ .ant-select {
      width: 120px;
      height: 35px;
      margin-left: 10px;
    }

    /deep/ .ant-calendar-picker {
      width: 153px;
      height: 35px;
    }
  }

  .score-compare-statistic-box {
    width: 100%;
    height: 155px;

    .score-compare-info {
      width: 100%;
      display: flex;
      margin-top: 10px;

      .info-box-player {
        width: 22%;
      }
      .info-box-score {
        width: 26%;
      }
    }
    .info-box-title {
      width: 100%;
      height: 50px;
      text-align: center;
      font-family: 'Lantinghei SC';
      font-style: normal;
      font-weight: 600;
      font-size: 20px;
      line-height: 50px;
      letter-spacing: -0.015em;
      color: #000000;
      display: flex;

      .info-box-subtitle {
        width: 50%;
        text-align: center;

      }
    }
    .info-box-info {
      width: 100%;
      height: 35px;
      display: flex;

      .info-box-subinfo {
        width: 50%;
        text-align: center;
        font-family: 'DIN Alternate';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 35px;
        text-align: center;
        letter-spacing: -0.015em;
        color: #00375B;
        .medal-text {
          font-size: 20px; /* 比原来的字体小，可根据页面风格调整 */
          /* 可选：加一点间距让文字更舒展 */
          letter-spacing: 0.5px;
        }
      }
     .info-box-subinfo-in{
       width: 20%;
       text-align:right;
     }
      .info-box-subinfo-out{
        width: 30%;
      }
      .info-box-subinfo-out::after {
        content: " (外)";
        font-size: 12px;
      }
    }
    .info-box-info[target=_border] {
      border-left: black 1px solid;
    }
    .member-info {
      text-overflow: ellipsis;
      height: 24px;
      white-space: nowrap;
      justify-content: center;
      gap: 8px;
      //display: flex;
      .flag {
        width: 30px;
        height: 20px;
        margin: 8px 0px;
        margin-right: 8%;
      }
      .icon {
        width: 35px;
        height: 35px;
        border-radius: 50%;
        display: inline-block;
        object-fit: cover;
        object-position: top;
      }
      .member-name {
        margin-left: 8%;
        font-family: 'Lantinghei SC';
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        line-height: 35px;
        letter-spacing: -0.015em;
        color: #00375B;
      }
    }
  }

  .score-compare-list-box {
    height: calc(100% - 276px);

    .list-empty {
      width: 100%;
      height: calc(100% - 80px);
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .list-box {
      width: 100%;
      height: calc(100% - 80px);
      margin-top: 20px;
      padding: 2px;
      overflow-y: scroll;

      display: grid;
      justify-content: space-between;
      grid-template-columns: repeat(auto-fill, 560px);
      grid-template-rows: repeat(auto-fill, 160px);
      grid-row-gap: 21px;
    }
    // .list-box::-webkit-scrollbar {
    //   // display: none;
    // }
    .list-box-cell {
      width: 560px;
      height: 160px;
      margin-right: 5px;
    }
  }
  .score-compare-close-button {
    height: 53px;

    /deep/ .ant-btn-primary {
      font-size: 20px;
      line-height: 45px;
    }
  }

  /deep/ .ant-btn-primary {
    background: #0072BE;
    border-color: #0072BE;

    font-family: 'Lantinghei SC';
    font-style: normal;
    font-weight: 400;

    letter-spacing: -0.015em;
    }
}
</style>
